import { useThemeMode, useUk } from '../../../hooks'
import { CompanyLink, CompanyLogo } from '../../Company'
import { MenuDefaultLogo } from '../MenuDefaultLogo'

import { hasMenuCompanyLogo } from './MenuLogo.utils'

import * as styles from './MenuLogo.module.css'

function MenuLogo({
  Link = CompanyLink,
  className = styles.MenuLogo,
  collapsed,
}) {
  const uk = useUk()

  const { theme } = useThemeMode()

  const hasCompanyLogo = hasMenuCompanyLogo({ collapsed, theme, uk })

  const logo = hasCompanyLogo ? (
    <CompanyLogo className={styles.companyLogo} collapsed={collapsed} />
  ) : (
    <MenuDefaultLogo className={styles.logo} collapsed={collapsed} />
  )

  return Link ? (
    <Link className={className}>{logo}</Link>
  ) : (
    <div className={className}>{logo}</div>
  )
}

export default MenuLogo
